function debounce(func, wait) {
  let timeout;
  const debounced = function(...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
  debounced.cancel = function() {
    clearTimeout(timeout);
  };
  return debounced;
}

class GridVariantSelector extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('button');
    this.mainImage = this.closest('.product-grid-item')?.querySelector('.product-grid-item__image img'); 
    this.allowNavigation = this.dataset.allowNavigation === 'true';
    // Store original image data
    if (this.mainImage) {
      this.originalSrc = this.mainImage.src;
      this.originalSrcset = this.mainImage.srcset;
    }

    // Initialize debounced revert function
    this.debouncedRevert = debounce(this.revertToOriginalOrSelected.bind(this), 500);

    this.buttons.forEach(button => {
      button.addEventListener('mouseenter', this.onVariantHover.bind(this));
      button.addEventListener('mouseleave', this.onVariantLeave.bind(this));
      button.addEventListener('click', this.onVariantClick.bind(this));
    });
  }

  onVariantHover(event) {
    this.debouncedRevert.cancel();
    const start = Date.now();
    const image = event.target.dataset.image;
    const srcset = event.target.dataset.srcset;
    if (image && this.mainImage) {
      this.mainImage.src = image;
      if (srcset) this.mainImage.srcset = srcset;
    }
  }

  onVariantLeave(event) {
    this.debouncedRevert();
  }

  revertToOriginalOrSelected() {
    if (!this.selectedVariant) {
      this.revertImage();
    } else {
      // Revert to selected variant image
      const selectedBtn = this.querySelector('button[aria-pressed="true"]');
      if (selectedBtn) {
        const image = selectedBtn.dataset.image;
        const srcset = selectedBtn.dataset.srcset;
        if (image && this.mainImage) {
          this.mainImage.src = image;
          if (srcset) this.mainImage.srcset = srcset;
        }
      }
    }
  }

  onVariantClick(event) {
    if(!this.allowNavigation) {
      event.preventDefault(); // Prevent navigating if inside <a>?
      // Actually the item title is wrapped in <a>. The whole card often is clickable or has an overlay link.
      // The snippet shows `data-grid-link` often used for full-card link.
      // I need to stop propagation.
      event.stopPropagation();
    }
    
    const button = event.currentTarget;
    const variantId = button.dataset.variantId;
    const url = button.dataset.url;
    
    // Update selected state
    this.buttons.forEach(btn => btn.setAttribute('aria-pressed', 'false'));
    button.setAttribute('aria-pressed', 'true');
    this.selectedVariant = variantId;

    // Update Image (persistent now)
    const image = button.dataset.image;
    const srcset = button.dataset.srcset;
    if (image && this.mainImage) {
      this.mainImage.src = image;
      if (srcset) this.mainImage.srcset = srcset;
      // Update original so hover revert works correctly
      // this.originalSrc = image;
      // this.originalSrcset = srcset; 
      // Actually, if we select, "revert" means go back to selected.
    }
    
    // Update URL of the product card if possible? 
    // The snippet renders links separately.
    // Typically we want the user to go to the variant URL if they click the card later.
    const links = this.closest('.product-grid-item')?.querySelectorAll('a[data-grid-link]');
    if (links) {
        links.forEach(link => {
            if (link.href.includes('/products/')) {
                // simple replacement or query param append
                const startUrl = link.href.split('?')[0];
                link.href = `${startUrl}?variant=${variantId}`;
            }
        });
    }
  }

  revertImage() {
    if (this.mainImage && this.originalSrc) {
      this.mainImage.src = this.originalSrc;
      if (this.originalSrcset) this.mainImage.srcset = this.originalSrcset;
    }
  }
}

if (!customElements.get('grid-variant-selector')) {
  customElements.define('grid-variant-selector', GridVariantSelector);
}
